import React, { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';

import buttonStyles from './CustomButton.module.scss';
import s from './DownloadButton.module.scss';

interface DownloadButtonProps {
  text: string;
  link: string;
}

const DownloadButton = (props: DownloadButtonProps): ReactElement => {
  const { text, link } = props;
  return (
    <div className={s.downloadButtonContainer}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonStyles.wrapper}
      >
        <div className={s.button}>
          <span>{text}</span>
          <FontAwesomeIcon className={s.icon} icon={faFilePdf} />
        </div>
      </a>
    </div>
  );
};

export default DownloadButton;
